import { render, staticRenderFns } from "./OssMultiUpload.vue?vue&type=template&id=9ed276be"
import script from "./OssMultiUpload.vue?vue&type=script&lang=js"
export * from "./OssMultiUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports